import React from 'react';

const MainMenu = ({ onQuickPlay, onCreateLobby, onJoinLobby }) => {
  return (
    <div className="game-card">
      <h1><span role="img" aria-label="target">🎯</span> DunnoHack 2</h1>
      <p>Test your knowledge with our online trivia game!</p>
      
      <div className="menu-options">
        <button 
          className="menu-button primary" 
          onClick={onCreateLobby}
        >
          <span role="img" aria-label="users">👥</span>
          Create Lobby
          <small>Start a multiplayer game</small>
        </button>
        
        <button 
          className="menu-button secondary" 
          onClick={onJoinLobby}
        >
          <span role="img" aria-label="key">🔑</span>
          Join Lobby
          <small>Enter a lobby code</small>
        </button>
        
        <button 
          className="menu-button tertiary" 
          onClick={onQuickPlay}
        >
          <span role="img" aria-label="play">⚡</span>
          Quick Play
          <small>Single player mode</small>
        </button>
      </div>

      <div className="game-info">
        <div className="info-section">
          <h3>📚 About the Questions</h3>
          <p>
            Questions are provided by <strong>OpenTDB</strong>, a free trivia database. 
            We are not affiliated with OpenTDB, but we're grateful for their amazing service!
          </p>
          <p>
            <a href="https://opentdb.com/" target="_blank" rel="noopener noreferrer" className="info-link">
              Visit OpenTDB to contribute questions
            </a>
          </p>
        </div>

        <div className="info-section">
          <h3>🎮 Inspiration</h3>
          <p>
            This game is inspired by <strong>"You Don't Know Jack"</strong>, the classic trivia game 
            that brought humor and personality to trivia. While we're not affiliated with the 
            original creators, we hope to capture some of that same fun spirit!
          </p>
        </div>

        <div className="info-section">
          <h3>🌟 Features</h3>
          <ul className="feature-list">
            <li>🎯 Multiple difficulty levels</li>
            <li>📊 Real-time multiplayer scoring</li>
            <li>🎵 Sound effects and music</li>
            <li>📱 Responsive design</li>
            <li>🔊 Mute option for quiet play</li>
          </ul>
        </div>

        <div className="info-section">
          <h3>🤖 Built With</h3>
          <p>
            This game was built with assistance from <strong>Cursor</strong>, 
            an AI-powered code editor.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
